"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Widget = function Widget(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.7,23.8H0.5c-0.2,0-0.3-0.1-0.3-0.3v-9.2c0-0.2,0.1-0.3,0.3-0.3h9.2c0.2,0,0.3,0.1,0.3,0.3v9.2C10,23.7,9.8,23.8,9.7,23.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.4,23.8h-9.2c-0.2,0-0.3-0.1-0.3-0.3v-9.2c0-0.2,0.1-0.3,0.3-0.3h9.2c0.2,0,0.3,0.1,0.3,0.3v9.2C20.7,23.7,20.6,23.8,20.4,23.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.7,13H0.5c-0.2,0-0.3-0.1-0.3-0.3V3.5c0-0.2,0.1-0.3,0.3-0.3h9.2c0.2,0,0.3,0.1,0.3,0.3v9.2C10,12.9,9.8,13,9.7,13z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,7.5L17,13.9c-0.1,0.1-0.3,0.1-0.4,0l-6.5-6.5C10,7.3,10,7.1,10.1,7l6.5-6.5c0.1-0.1,0.3-0.1,0.4,0L23.5,7C23.6,7.1,23.6,7.3,23.5,7.5z"
  }));
};

var _default = Widget;
exports["default"] = _default;